// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CatalogProduct from "./CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogProductEditForm from "./CatalogProductEditForm.res.js";
import * as CatalogProductTaxSelect from "./CatalogProductTaxSelect.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let InputColorUnexpectedKind = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormInputs.InputColorUnexpectedKind");

let make = React.memo(props => {
  let match = CatalogProduct.Color.toColorSet(props.color, "badge");
  let foregroundColor = match.foregroundColor;
  let borderColor = foregroundColor + "1A";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Badge.make, {
      children: props.children,
      borderColor: borderColor,
      backgroundColor: match.backgroundColor,
      foregroundColor: foregroundColor
    }),
    style: {
      alignSelf: "flex-start"
    }
  });
});

let ColorItem = {
  make: make
};

function CatalogProductEditFormInputs$ColorSelect(props) {
  let renderValue = param => {
    let selectedItems = param.selectedItems;
    if (selectedItems.length === 1) {
      let match = selectedItems[0];
      if (match.TAG === "Option") {
        let color = match.value;
        if (color !== undefined) {
          let colorLabel = CatalogProduct.Color.toLabel(color);
          return JsxRuntime.jsx(make, {
            children: colorLabel,
            color: color
          });
        }
      }
    }
    return JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("Select a color"),
      variation: "normal"
    });
  };
  let renderItem = param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let color = item.value;
    if (color === undefined) {
      return null;
    }
    let colorLabel = CatalogProduct.Color.toLabel(color);
    return JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(make, {
        children: colorLabel,
        color: color
      }),
      grow: false
    });
  };
  let match = CatalogProductEditForm.useFormState().initialValues.kind;
  let options;
  if (match === "BEER") {
    options = [
      "WHITE",
      "RED",
      "AMBER",
      "BLOND",
      "DARK",
      "BLACK"
    ];
  } else if (match === "WINE") {
    options = [
      "WHITE",
      "RED",
      "ROSE",
      "ORANGE"
    ];
  } else {
    throw {
      RE_EXN_ID: InputColorUnexpectedKind,
      Error: new Error()
    };
  }
  let sections = [{
      items: options.map(color => ({
        TAG: "Option",
        key: CatalogProduct.Color.toString(color),
        label: CatalogProduct.Color.toString(color),
        value: color
      }))
    }];
  return JsxRuntime.jsx(CatalogProductEditForm.InputSelect.make, {
    field: "Color",
    label: I18n.t("Color"),
    searchable: false,
    renderItem: renderItem,
    sections: sections,
    renderValue: renderValue
  });
}

let ColorSelect = {
  ColorItem: ColorItem,
  make: CatalogProductEditFormInputs$ColorSelect
};

function CatalogProductEditFormInputs$WineTypeSelect(props) {
  let options = [
    "STILL",
    "EFFERVESCENT"
  ];
  let items = options.map(wineType => ({
    TAG: "Option",
    key: CatalogProduct.WineType.toString(wineType),
    label: CatalogProduct.WineType.toLabel(wineType),
    value: wineType
  }));
  let sections = [{
      items: items
    }];
  return JsxRuntime.jsx(CatalogProductEditForm.InputSelect.make, {
    field: "WineType",
    label: I18n.t("Wine type"),
    placeholder: I18n.t("Select a wine type"),
    sections: sections
  });
}

let WineTypeSelect = {
  make: CatalogProductEditFormInputs$WineTypeSelect
};

function CatalogProductEditFormInputs$WhiteWineTypeSelect(props) {
  let options = [
    "DRY",
    "SEMIDRY",
    "SOFT",
    "SWEET"
  ];
  let items = options.map(whiteWineType => ({
    TAG: "Option",
    key: CatalogProduct.WhiteWineType.toString(whiteWineType),
    label: CatalogProduct.WhiteWineType.toLabel(whiteWineType),
    value: whiteWineType
  }));
  let sections = [{
      items: items
    }];
  return JsxRuntime.jsx(CatalogProductEditForm.InputSelect.make, {
    field: "WhiteWineType",
    label: I18n.t("White wine type"),
    placeholder: I18n.t("Select a white wine type"),
    sections: sections
  });
}

let WhiteWineTypeSelect = {
  make: CatalogProductEditFormInputs$WhiteWineTypeSelect
};

let Raw = {};

let query = Client.gql(["query productProducers  {\nproductProducers  \n}\n"]);

function parse(value) {
  let value$1 = value.productProducers;
  return {
    productProducers: value$1.map(value => value)
  };
}

function serialize(value) {
  let value$1 = value.productProducers;
  let productProducers = value$1.map(value => value);
  return {
    productProducers: productProducers
  };
}

function serializeVariables() {
  
}

function makeVariables() {
  
}

function makeDefaultVariables() {
  
}

let ProductProducersQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ProductProducersQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductProducersQuery_useLazy = include.useLazy;

let ProductProducersQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductProducersQuery = {
  ProductProducersQuery_inner: ProductProducersQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ProductProducersQuery_refetchQueryDescription,
  use: use,
  useLazy: ProductProducersQuery_useLazy,
  useLazyWithVariables: ProductProducersQuery_useLazyWithVariables
};

function CatalogProductEditFormInputs$ProductProducerComboBox(props) {
  let results = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let match = results.data;
  return JsxRuntime.jsx(CatalogProductEditForm.InputSuggestionComboBox.make, {
    field: "Producer",
    label: I18n.t("Producer"),
    placeholder: I18n.t("Add a producer"),
    hideRequired: true,
    items: match !== undefined ? match.productProducers.filter(suggestion => suggestion !== "").map(productProducer => ({
        value: productProducer
      })) : []
  });
}

let ProductProducerComboBox = {
  ProductProducersQuery: ProductProducersQuery,
  make: CatalogProductEditFormInputs$ProductProducerComboBox
};

let Raw$1 = {};

let query$1 = Client.gql(["query productWineDesignations  {\nproductWineDesignations  \n}\n"]);

function parse$1(value) {
  let value$1 = value.productWineDesignations;
  return {
    productWineDesignations: value$1.map(value => value)
  };
}

function serialize$1(value) {
  let value$1 = value.productWineDesignations;
  let productWineDesignations = value$1.map(value => value);
  return {
    productWineDesignations: productWineDesignations
  };
}

function serializeVariables$1() {
  
}

function makeVariables$1() {
  
}

function makeDefaultVariables$1() {
  
}

let ProductWineDesignationsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let ProductWineDesignationsQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let ProductWineDesignationsQuery_useLazy = include$1.useLazy;

let ProductWineDesignationsQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let ProductWineDesignationsQuery = {
  ProductWineDesignationsQuery_inner: ProductWineDesignationsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: ProductWineDesignationsQuery_refetchQueryDescription,
  use: use$1,
  useLazy: ProductWineDesignationsQuery_useLazy,
  useLazyWithVariables: ProductWineDesignationsQuery_useLazyWithVariables
};

function CatalogProductEditFormInputs$ProductDesignationComboBox(props) {
  let results = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let match = results.data;
  return JsxRuntime.jsx(CatalogProductEditForm.InputSuggestionComboBox.make, {
    field: "Designation",
    label: I18n.t("Designation"),
    placeholder: I18n.t("Add a designation"),
    items: match !== undefined ? match.productWineDesignations.filter(suggestion => suggestion !== "").map(productWineDesignation => ({
        value: productWineDesignation
      })) : []
  });
}

let ProductDesignationComboBox = {
  ProductWineDesignationsQuery: ProductWineDesignationsQuery,
  make: CatalogProductEditFormInputs$ProductDesignationComboBox
};

let Raw$2 = {};

let query$2 = Client.gql(["query productSpirituousFamilies  {\nproductSpirituousFamilies  \n}\n"]);

function parse$2(value) {
  let value$1 = value.productSpirituousFamilies;
  return {
    productSpirituousFamilies: value$1.map(value => value)
  };
}

function serialize$2(value) {
  let value$1 = value.productSpirituousFamilies;
  let productSpirituousFamilies = value$1.map(value => value);
  return {
    productSpirituousFamilies: productSpirituousFamilies
  };
}

function serializeVariables$2() {
  
}

function makeVariables$2() {
  
}

function makeDefaultVariables$2() {
  
}

let ProductSpirituousFamiliesQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  makeDefaultVariables: makeDefaultVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let ProductSpirituousFamiliesQuery_refetchQueryDescription = include$2.refetchQueryDescription;

let ProductSpirituousFamiliesQuery_useLazy = include$2.useLazy;

let ProductSpirituousFamiliesQuery_useLazyWithVariables = include$2.useLazyWithVariables;

let ProductSpirituousFamiliesQuery = {
  ProductSpirituousFamiliesQuery_inner: ProductSpirituousFamiliesQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  makeDefaultVariables: makeDefaultVariables$2,
  refetchQueryDescription: ProductSpirituousFamiliesQuery_refetchQueryDescription,
  use: use$2,
  useLazy: ProductSpirituousFamiliesQuery_useLazy,
  useLazyWithVariables: ProductSpirituousFamiliesQuery_useLazyWithVariables
};

function CatalogProductEditFormInputs$ProductFamilyComboBox(props) {
  let results = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let match = results.data;
  return JsxRuntime.jsx(CatalogProductEditForm.InputSuggestionComboBox.make, {
    field: "Family",
    label: I18n.t("Family"),
    placeholder: I18n.t("Add a family"),
    items: match !== undefined ? match.productSpirituousFamilies.filter(suggestion => suggestion !== "").map(productSpirituousFamily => ({
        value: productSpirituousFamily
      })) : []
  });
}

let ProductFamilyComboBox = {
  ProductSpirituousFamiliesQuery: ProductSpirituousFamiliesQuery,
  make: CatalogProductEditFormInputs$ProductFamilyComboBox
};

let Raw$3 = {};

let query$3 = Client.gql(["query productBeerTypes  {\nproductBeerTypes  \n}\n"]);

function parse$3(value) {
  let value$1 = value.productBeerTypes;
  return {
    productBeerTypes: value$1.map(value => value)
  };
}

function serialize$3(value) {
  let value$1 = value.productBeerTypes;
  let productBeerTypes = value$1.map(value => value);
  return {
    productBeerTypes: productBeerTypes
  };
}

function serializeVariables$3() {
  
}

function makeVariables$3() {
  
}

function makeDefaultVariables$3() {
  
}

let ProductBeerTypesQuery_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables$3
};

let include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});

let use$3 = include$3.use;

let ProductBeerTypesQuery_refetchQueryDescription = include$3.refetchQueryDescription;

let ProductBeerTypesQuery_useLazy = include$3.useLazy;

let ProductBeerTypesQuery_useLazyWithVariables = include$3.useLazyWithVariables;

let ProductBeerTypesQuery = {
  ProductBeerTypesQuery_inner: ProductBeerTypesQuery_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables$3,
  refetchQueryDescription: ProductBeerTypesQuery_refetchQueryDescription,
  use: use$3,
  useLazy: ProductBeerTypesQuery_useLazy,
  useLazyWithVariables: ProductBeerTypesQuery_useLazyWithVariables
};

function CatalogProductEditFormInputs$ProductBeerTypeComboBox(props) {
  let results = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let match = results.data;
  return JsxRuntime.jsx(CatalogProductEditForm.InputSuggestionComboBox.make, {
    field: "BeerType",
    label: I18n.t("Beer type"),
    placeholder: I18n.t("Add a beer type"),
    items: match !== undefined ? match.productBeerTypes.filter(suggestion => suggestion !== "").map(productBeerType => ({
        value: productBeerType
      })) : []
  });
}

let ProductBeerTypeComboBox = {
  ProductBeerTypesQuery: ProductBeerTypesQuery,
  make: CatalogProductEditFormInputs$ProductBeerTypeComboBox
};

let Raw$4 = {};

let query$4 = Client.gql(["query productRegions($country: String)  {\nproductRegions(country: $country)  \n}\n"]);

function parse$4(value) {
  let value$1 = value.productRegions;
  return {
    productRegions: value$1.map(value => value)
  };
}

function serialize$4(value) {
  let value$1 = value.productRegions;
  let productRegions = value$1.map(value => value);
  return {
    productRegions: productRegions
  };
}

function serializeVariables$4(inp) {
  let a = inp.country;
  return {
    country: a !== undefined ? a : undefined
  };
}

function makeVariables$4(country) {
  return {
    country: country
  };
}

function makeDefaultVariables$4() {
  return {
    country: undefined
  };
}

let ProductRegionsQuery_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$4
};

let include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4
});

let use$4 = include$4.use;

let ProductRegionsQuery_refetchQueryDescription = include$4.refetchQueryDescription;

let ProductRegionsQuery_useLazy = include$4.useLazy;

let ProductRegionsQuery_useLazyWithVariables = include$4.useLazyWithVariables;

let ProductRegionsQuery = {
  ProductRegionsQuery_inner: ProductRegionsQuery_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$4,
  refetchQueryDescription: ProductRegionsQuery_refetchQueryDescription,
  use: use$4,
  useLazy: ProductRegionsQuery_useLazy,
  useLazyWithVariables: ProductRegionsQuery_useLazyWithVariables
};

function CatalogProductEditFormInputs$ProductRegionComboBox(props) {
  let match = CatalogProductEditForm.useFormState().values;
  let country = match.country;
  let queryVariableCountry;
  switch (country) {
    case "Afrique du Sud" :
      queryVariableCountry = "South Africa";
      break;
    case "Allemagne" :
      queryVariableCountry = "Germany";
      break;
    case "Argentine" :
      queryVariableCountry = "Argentina";
      break;
    case "Australie" :
      queryVariableCountry = "Australia";
      break;
    case "Autriche" :
      queryVariableCountry = "Austria";
      break;
    case "Croatie" :
      queryVariableCountry = "Croatia";
      break;
    case "Espagne" :
      queryVariableCountry = "Spain";
      break;
    case "Etats-Unis" :
      queryVariableCountry = "United States";
      break;
    case "Georgie" :
      queryVariableCountry = "Georgia";
      break;
    case "Grèce" :
      queryVariableCountry = "Greece";
      break;
    case "Hongrie" :
      queryVariableCountry = "Hungary";
      break;
    case "Israël" :
      queryVariableCountry = "Israel";
      break;
    case "Italie" :
      queryVariableCountry = "Italy";
      break;
    case "Liban" :
      queryVariableCountry = "Lebanon";
      break;
    case "Nouvelle Zélande" :
      queryVariableCountry = "New Zealand";
      break;
    case "Slovaquie" :
      queryVariableCountry = "Slovakia";
      break;
    case "Suisse" :
      queryVariableCountry = "Switzerland";
      break;
    default:
      queryVariableCountry = country;
  }
  let results = use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    country: queryVariableCountry
  });
  let match$1 = results.data;
  return JsxRuntime.jsx(CatalogProductEditForm.InputSuggestionComboBox.make, {
    field: "Region",
    label: I18n.t("Region"),
    placeholder: I18n.t("Add a region"),
    items: match$1 !== undefined ? match$1.productRegions.filter(suggestion => suggestion !== "").map(productRegion => ({
        value: productRegion
      })) : []
  });
}

let ProductRegionComboBox = {
  ProductRegionsQuery: ProductRegionsQuery,
  make: CatalogProductEditFormInputs$ProductRegionComboBox
};

function CatalogProductEditFormInputs$ProductCountrySelect(props) {
  return JsxRuntime.jsx(CatalogProductEditForm.InputCountrySelect.make, {
    field: "Country",
    subdivisionsIncluded: true
  });
}

let ProductCountrySelect = {
  make: CatalogProductEditFormInputs$ProductCountrySelect
};

function CatalogProductEditFormInputs$ProductTaxSelect(props) {
  let match = CatalogProductEditForm.useFormState();
  let dispatch = CatalogProductEditForm.useFormDispatch();
  let defaultTaxValue = props.productKind === "SIMPLE" ? 5.5 : undefined;
  let value = Stdlib_Option.map(match.values.tax, tax => ({
    id: tax.id,
    value: tax.value
  }));
  let onChange = React.useCallback(tax => dispatch({
    TAG: "FieldValueChanged",
    _0: "Tax",
    _1: param => ({
      id: tax.id,
      value: tax.value
    })
  }), []);
  return JsxRuntime.jsx(CatalogProductTaxSelect.make, {
    value: value,
    defaultTaxValue: defaultTaxValue,
    onChange: onChange
  });
}

let ProductTaxSelect = {
  make: CatalogProductEditFormInputs$ProductTaxSelect
};

export {
  InputColorUnexpectedKind,
  ColorSelect,
  WineTypeSelect,
  WhiteWineTypeSelect,
  ProductProducerComboBox,
  ProductDesignationComboBox,
  ProductFamilyComboBox,
  ProductBeerTypeComboBox,
  ProductRegionComboBox,
  ProductCountrySelect,
  ProductTaxSelect,
}
/* make Not a pure module */
